import _TreeSelect from './tree-select';

import './style';

export type { TreeSelectProps } from './tree-select';
export * from './type';

export const TreeSelect = _TreeSelect;
export default TreeSelect;
